import comp from "./ResourceItemCard";
export default comp;
